import { render, staticRenderFns } from "./update-files.dialog.vue?vue&type=template&id=422a5fc0&scoped=true"
import script from "./update-files.dialog.vue?vue&type=script&lang=js"
export * from "./update-files.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a5fc0",
  null
  
)

export default component.exports